import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const CommunityGuidelines = lazy(() => import("@/pages/policies/CommunityGuidelines"));

export const Route = createFileRoute("/_public/community-guidelines")({
  component: CommunityGuidelines,
});
